import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Security } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";

import { UserProvider } from "@/contexts/user";
import { getOktaAuthConfig } from "@/constants/okta";
import { PaysProvider } from "@/contexts/pays";
import { useConfig } from "@/contexts/config";
import Router from "@/router/Router";
import axiosClient from "@/api/axiosClient";

const App = () => {
  const navigate = useNavigate();
  const { config } = useConfig();
  const [configurationEnCours, setConfigurationEnCours] = useState(true);

  useEffect(() => {
    if (config) {
      axiosClient.defaults.baseURL = config["API_END_POINT"];
      localStorage.setItem(
        "IMAGE_MANAGER_URL_GET",
        config["IMAGE_MANAGER_URL"]
      );
      setConfigurationEnCours(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config]);

  if (configurationEnCours) return <></>;

  return (
    <Security
      oktaAuth={new OktaAuth(getOktaAuthConfig(config))}
      onAuthRequired={() => navigate("/login")}
      restoreOriginalUri={async (_oktaAuth: any, originalUri: string) => {
        navigate(toRelativeUrl(originalUri, window.location.origin));
      }}
    >
      <UserProvider>
        <PaysProvider>
          <Router />
        </PaysProvider>
      </UserProvider>
    </Security>
  );
};

export default App;
